export default {
      id: "arrow-title-usage",
      viewBox: "0 0 23 13",
      url: __webpack_public_path__ + "img/icons.c3436384.svg#arrow-title",
      toString: function () {
        return this.url;
      }
    }